import React, { useState } from "react";
import EmailSender from '../../api/EmailSender';
import img from "../../assets/img/common/vendor.png";

const BookYourTravel = () => {
  const { isSubmitting, succeeded, error, sendEmail } = EmailSender();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const success = await sendEmail(
      formData,
      "New Travel Booking Request from House of Polani"
    );

    if (success) {
      setFormData({
        name: "",
        email: "",
        phone: "",
        service: "",
        message: "",
      });
    }
  };

  return (
    <>
      <section id="vendor_form_area" className="" style={{ marginBottom: "40px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="vendor_form_heading">
                <h2>Book Your Travel Experience</h2>
                <p>
                  Transform your travel dreams into reality with House of
                  Polani. Whether you're planning a corporate trip, religious
                  pilgrimage, or leisure vacation, our expert team is ready to
                  assist you. Complete the form below, and we'll create a
                  personalized travel solution tailored to your needs.
                </p>
              </div>
              <div className="vendor_form" style={{ marginRight: "10px" }}>
                <div className="tour_booking_form_box">
                  <form onSubmit={handleSubmit} id="tour_bookking_form_item">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="Full Name*"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control bg_input"
                            placeholder="Email Address"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="tel"
                            className="form-control bg_input"
                            placeholder="Phone Number*"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <select
                            className="form-control form-select bg_input"
                            name="service"
                            value={formData.service}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled>Select Service</option>
                            <option value="Corporate Travel">Corporate Travel</option>
                            <option value="E-Ticket Services">E-Ticket Services</option>
                            <option value="International Reservations">International Reservations</option>
                            <option value="Domestic Reservations">Domestic Reservations</option>
                            <option value="International Rail Booking">International Rail Booking</option>
                            <option value="Car Rental">Car Rental</option>
                            <option value="Worldwide Visa">Worldwide Visa</option>
                            <option value="Passport Services">Passport Services</option>
                            <option value="NADRA Services">NADRA Services</option>
                            <option value="Travel Insurance">Travel Insurance</option>
                            <option value="Holiday Packages">Holiday Packages</option>
                            <option value="Cruise Packages">Cruise Packages</option>
                            <option value="MICE Group Tours">MICE Group Tours</option>
                            <option value="Hajj Services">Hajj Services</option>
                            <option value="Umrah Services">Umrah Services</option>
                            <option value="Ziarat Services">Ziarat Services</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <textarea
                            className="form-control bg_input"
                            placeholder="Additional Details (Optional)"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="4"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="booking_tour_form_submit pt-4">
                      {succeeded && (
                        <div className="alert alert-success" role="alert" style={{backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb", borderRadius: "4px", padding: "15px", marginBottom: "20px"}}>
                          <h4 className="alert-heading" style={{color: "#155724"}}>Thank You!</h4>
                          <p>
                            We've received your booking request. Our team will
                            contact you shortly to discuss your travel plans
                            and create a personalized solution for you.
                          </p>
                        </div>
                      )}
                      {error && (
                        <div className="alert alert-danger" role="alert">
                          <p>{error}</p>
                        </div>
                      )}
                      <button
                        type="submit"
                        className="btn btn_theme btn_md"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="vendor_img">
                <img src={img} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookYourTravel;
